
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.998 1.895l10.184 4.73 2.507 10.597-7.036 8.51H9.341l-7.036-8.51L4.813 6.625zm11.804 3.438L14.998-.15 3.193 5.333.27 17.688l8.181 9.895h13.093l8.181-9.895z"}}),_c('path',{attrs:{"d":"M14.998 11.23c1.62 0 2.94 1.302 2.94 2.9 0 1.6-1.32 2.901-2.94 2.901-1.62 0-2.94-1.302-2.94-2.9 0-1.6 1.32-2.901 2.94-2.901zm0-1.29c-2.343 0-4.248 1.88-4.248 4.19 0 2.311 1.905 4.19 4.248 4.19 2.342 0 4.247-1.879 4.247-4.19 0-2.31-1.905-4.19-4.247-4.19zm0-.644a4.92 4.92 0 014.142 2.256h1.411v6.446c0 .89-.731 1.612-1.633 1.612h-7.841a1.623 1.623 0 01-1.633-1.612v-6.446h1.411a4.918 4.918 0 014.142-2.256zm4.247-.645h.98c.18 0 .326.146.326.323v.967a.325.325 0 01-.326.322h-.98a.325.325 0 01-.327-.322v-.967c0-.177.147-.323.327-.323zM10.75 7.04c-1.62 0-2.94 1.302-2.94 2.9v8.38c0 1.599 1.32 2.901 2.94 2.901h8.495c1.62 0 2.94-1.302 2.94-2.9V9.94c0-1.599-1.32-2.901-2.94-2.901z"}})])
          )
        }
      }
    